import { Membership_Type } from '@occc/graphql';

export const memberEmployeeStatusLabels: Record<Membership_Type, string> = {
  [Membership_Type.Standard]: 'Member',
  [Membership_Type.Employee]: 'Employee',
  [Membership_Type.Manager]: 'Manager',
  [Membership_Type.RcUser]: 'RC User',
};

export const memberEmployeeStatusOptions = [
  Membership_Type.Standard,
  Membership_Type.Employee,
  Membership_Type.Manager,
];
